import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect } from 'react';
import { triggerNotificationsRenderAborted, triggerNotificationsRenderFailed, triggerNotificationsRenderSucceeded, useCreateFireAnalyticsFromTrigger } from '../analytics';
import { SloFailureReason } from '../analytics/types';
import { useExperienceTracker } from './adapter/context';
import { AbortReason, ExperienceIds, Experiences } from './types';
import { getExperienceTimeout, getNotificationMountStartMark } from './utils';
export var useNotificationsExperienceTracking = function useNotificationsExperienceTracking() {
  var experienceTracker = useExperienceTracker();
  var fireNotificationsRenderSucceeded = useCreateFireAnalyticsFromTrigger(triggerNotificationsRenderSucceeded);
  var fireNotificationsRenderFailed = useCreateFireAnalyticsFromTrigger(triggerNotificationsRenderFailed);
  var fireNotificationsRenderAborted = useCreateFireAnalyticsFromTrigger(triggerNotificationsRenderAborted);
  useEffect(function () {
    return function () {
      experienceTracker.abort({
        name: Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT,
        reason: AbortReason.COMPONENT_UNMOUNTED
      });
      experienceTracker.abort({
        name: Experiences.RENDER_NOTIFICATIONS_WITHOUT_CONTENT,
        reason: AbortReason.COMPONENT_UNMOUNTED
      });
      experienceTracker.abort({
        name: Experiences.RENDER_NOTIFICATION_PAGE_WITH_CONTENT,
        reason: AbortReason.COMPONENT_UNMOUNTED
      });
    };
  }, [experienceTracker]);
  useEffect(function () {
    return setupExperienceTracking(experienceTracker, fireNotificationsRenderSucceeded, fireNotificationsRenderFailed, fireNotificationsRenderAborted);
  }, [experienceTracker, fireNotificationsRenderSucceeded, fireNotificationsRenderFailed, fireNotificationsRenderAborted]);
};
var setupExperienceTracking = function setupExperienceTracking(experienceTracker, fireNotificationsRenderSucceeded, fireNotificationsRenderFailed, fireNotificationsRenderAborted) {
  return experienceTracker.subscribe(function (event) {
    if (event.name === Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT || event.name === Experiences.RENDER_NOTIFICATIONS_WITHOUT_CONTENT) {
      var _withContent = event.name === Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT;
      var _firstLoad = event.id === ExperienceIds.FIRST_LOAD;
      var _duration;
      var _getNotificationMount = getNotificationMountStartMark(),
        _getNotificationMount2 = _slicedToArray(_getNotificationMount, 2),
        performance = _getNotificationMount2[0],
        customStartTime = _getNotificationMount2[1];
      if (customStartTime !== undefined) {
        var nowMark = performance.now();
        _duration = nowMark - customStartTime;
      }
      var totalDuration = _duration || event.duration;
      if (event.action === 'taskSuccess') {
        var successAttributes = event.attributes;
        fireNotificationsRenderSucceeded(_firstLoad, _withContent, totalDuration, (successAttributes === null || successAttributes === void 0 ? void 0 : successAttributes.noNotificationsScreen) || false);
      } else if (event.action === 'taskFail') {
        fireNotificationsRenderFailed(_firstLoad, _withContent, totalDuration, event.error.message, event.attributes || {});
      } else if (event.action === 'taskAbort') {
        if (event.reason === AbortReason.COMPONENT_UNMOUNTED) {
          var timeout = getExperienceTimeout(event.name);
          if (totalDuration > timeout) {
            fireNotificationsRenderFailed(_firstLoad, _withContent, totalDuration, SloFailureReason.ABORT_TIMEOUT, event.attributes || {});
            return;
          }
        }
        fireNotificationsRenderAborted(_firstLoad, _withContent, totalDuration, event.reason, event.attributes || {});
      }
    }
  });
};
export var NotificationsExperienceTracker = function NotificationsExperienceTracker(_ref) {
  var children = _ref.children;
  useNotificationsExperienceTracking();
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
export var generateNotificationContentRenderExperienceName = function generateNotificationContentRenderExperienceName(notification) {
  return {
    name: Experiences.RENDER_INDIVIDUAL_NOTIFICATION_WITH_CONTENT,
    nameId: notification.id
  };
};